<script>
    import liberarProvisoesPagamento from '../servico';
    import Paginacao from '~componentes/Paginacao.vue';
    import Radio from '~componentes/Radio.vue';
    import { checkbox } from 'vue-strap';
    import 'select2';
    import 'select2/dist/js/i18n/pt-BR';
    import projetoServico from '~modulos/projeto/servico';
    import ModalLiberarProvisoes from '~componentes/ModalLiberarProvisoes.vue';

    export default {
      name: 'NomeDoComponente',
      components: {
        Paginacao,
        Radio,
        checkbox,
        ModalLiberarProvisoes,
      },
      data() {
        return {
          provisoes: [],
          carregando: false,
          pagina: 1,
          totalRegistros: 0,
          totalPaginas: 0,
          registrosPorPagina: 0,
          animated: true,
          solicitacaoSelecionada: null,
          configuracao: this.$storage.configuracao(),
          filtros: this.camposFiltros(),
          projetos: [],
          selecionarTudo: '0',
          modalLiberarProvisoes: false,
          salvandoLiberacao: false,
        }
      },
      methods: {
        modalLiberarProvisoesFechado() {
            this.animated = false;
            this.modalLiberarProvisoes = false;
        },
        mostrarModalLiberarProvisoes() {
          let mostrar = false;

          for (let i = 0; i < this.provisoes.length; i++) {
            if (this.provisoes[i].selecionado === "1") {
              mostrar = true;
              break;
            }
          }

          if (mostrar) {
            this.modalLiberarProvisoes = mostrar;
          }
          else {
            this.$swal(
              '',
              'É necessário selecionar pelo menos uma provisão para liberação. ',
              'info'
            );
          }
        },
        alinhacheckbox() {
          let totalckb = document.querySelectorAll('.ckbselecionado').length;

          for (let i = 0; i < totalckb; i++) {
            document.querySelectorAll('.ckbselecionado')[i].firstElementChild.setAttribute('style', 'position: relative; margin-right: 15px;');
          }
        },
        listaDeProjetos() {
          return projetoServico
            .listaDeProjetosPermissao('LiberarProvisoesPagamento')
            .then(projetos => {
              this.projetos = projetos;
            });
        },
        camposFiltros() {
          return {
            IdProjeto: '0',
            mostrarProvisoes: '2'
          };
        },
        limparFiltros() {
          this.filtros = this.camposFiltros();
          this.$nextTick(() => {
            $('#projeto').val(0).trigger('change.select2');
          });
          this.selecionarTudo = '0';

          this.lista();
        },
        mostrarEsconderFiltro(e) {
            if (!$(e.target).hasClass('fa-chevron-down') && !$(e.target).hasClass('fa-chevron-up')) {
                $('.collapse-link').trigger('click');
            }
        },
        lista(pagina = 1) {
          this.carregando = true;

          return liberarProvisoesPagamento.lista(pagina, this.filtros)
            .then(dados => {
              this.carregando = false;

              this.provisoes = dados.registros;
              this.totalRegistros = dados.totalRegistros;
              this.totalPaginas = dados.totalPaginas;
              this.registrosPorPagina = dados.registrosPorPagina;

              setTimeout(() => { this.alinhacheckbox(); }, 1000);
            });
        },
        status(provisao) {
            if (provisao.situacao === 1) {
                return 'Entrar em contato';
            } else if (provisao.situacao === 2) {
                return 'Aguardando liberação';
            } else if (provisao.situacao === 3) {
                return 'Liberada';
            } else if (provisao.situacao === 4) {
                return 'Pagamento efetuado';
            } else {
                return '';
            }
        },
        selecionar() {
          for (let i = 0; i < this.provisoes.length; i++) {
            if (this.selecionarTudo === "1"){
                if (!this.provisoes[i].disabledSelecionado)
                    this.provisoes[i].selecionado = "1"
            }
            else
            {
                this.provisoes[i].selecionado = "0"
            }
          }
        },
        liberar() {
            $('#liberar').button('loading');
            this.modalLiberarProvisoes = false;

            return liberarProvisoesPagamento
                .liberarProvisoes(this.provisoes)
                .then(() => {
                    $('#liberar').button('reset');

                    toastr.success(`Provisões selecionadas liberados com sucesso.`);
                    $('body').removeClass('modal-open');

                    if (this.$route.params.filtrosBag) {
                        this.pagina = this.$route.params.filtrosBag;
                        this.lista(this.pagina);
                        this.$refs.paginacao.handlePageSelected(this.pagina - 1);
                    }
                    else
                        this.lista();
                })
                .catch(erro => {
                $('#liberar').button('reset');

                this.$mensagemErro(erro, 'Erro ao tentar liberar as provisões.');
                });
          },
      },

      created() {
        this.lista();
      },

      mounted() {
        this.$root.tituloDaPagina = 'Liberar Provisões Pagamento - Lista';
        this.$root.botaoAcaoTexto = '';
        this.$root.botaoAcaoMostrar = false;

        this.$root.botaoRetrocederMostrar = false;
        this.$root.botaoRetrocederRota = '';

        this.listaDeProjetos();

        const _this = this;

        $('#projeto').select2({
          theme: "bootstrap",
          placeholder: "Selecione...",
          language: "pt-BR"
        })
          .change(function (e) {
            _this.$set(_this.filtros, 'IdProjeto', this.value);
          });

        $('.ibox').removeClass('collapsed');
      },
      watch: {
          "selecionarTudo" : "selecionar"
      },
      computed: {
        visibilidadeBotaoGerarProvisao()
        {
            return (this.provisoes.filter(p => p.selecionado == "1").length > 0);
        }
      }
    }
</script>

<template>
    <div :class="['wrapper wrapper-content ', {'animated': animated}, $root.animacaoPadrao]">
        <modal-liberar-provisoes :mostrar="modalLiberarProvisoes"
                                 :salvando="salvandoLiberacao"
                                 @fechado="modalLiberarProvisoesFechado"
                                 @liberar="liberar">
        </modal-liberar-provisoes>

        <div class="row">
            <div class="col-lg-12">
                <div class="ibox collapsed float-e-margins">
                    <div class="ibox-title pointer" @click="mostrarEsconderFiltro">
                        <h5>Filtrar lista <small class="m-l-sm">Clique para mostrar ou esconder os filtros</small></h5>

                        <div class="ibox-tools">
                            <span class="collapse-link">
                                <i class="fa fa-chevron-up"></i>
                            </span>
                        </div>
                    </div>
                    <div class="ibox-content">

                        <div class="row">
                            <div class="col-xs-8">
                                <div class="form-group">
                                    <label class="control-label" for="projeto">Projeto</label>

                                    <select id="projeto"
                                            class="form-control"
                                            v-model="filtros.idProjeto">
                                        <option value="0">Todos</option>
                                        <option :value="projeto.idProjeto" v-for="(projeto) in projetos">{{ projeto.nomeProjeto }}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-xs-4">
                                <div class="form-group">
                                    <label class="control-label block">Mostrar provisões</label>

                                    <radio v-model="filtros.mostrarProvisoes"
                                           selected-value="0"
                                           type="success"
                                           :inline="true"
                                           class="margin-right-10">
                                        Todas
                                    </radio>
                                    <radio v-model="filtros.mostrarProvisoes"
                                           selected-value="2"
                                           type="success"
                                           :inline="true"
                                           class="margin-right-10">
                                        Não liberadas
                                    </radio>
                                    <radio v-model="filtros.mostrarProvisoes"
                                           selected-value="3"
                                           type="success"
                                           :inline="true">
                                        Liberadas
                                    </radio>
                                    <radio v-model="filtros.mostrarProvisoes"
                                           selected-value="1"
                                           type="success"
                                           :inline="true">
                                        Pendentes
                                    </radio>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-12">
                                <div class="form-group no-margins">
                                    <button type="button" class="btn btn-primary no-margins" @click="lista">
                                        <i class="fa fa-search"></i>
                                        Filtrar
                                    </button>
                                    <button type="button" class="btn btn-default no-margins" @click="limparFiltros">
                                        <i class="fa fa-search"></i>
                                        Limpar filtros
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="ibox-footer">
                        <div class="table-responsive">
                            <table class="table table-bordered table-column-code table-column-action">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Data</th>
                                        <th>Projeto</th>
                                        <th>Beneficiário</th>
                                        <th>Valor</th>
                                        <th>Previsão</th>
                                        <th>Efetivação</th>
                                        <th>Contrato</th>
                                        <th>Status</th>
                                        <th>
                                            <checkbox class="ckbselecionado" value="0" type="success" true-value="1" false-value="0" v-model='selecionarTudo'>
                                            </checkbox>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(provisao, index) in provisoes">
                                        <td>
                                            <i class="fa fa-check-circle provisaoliberada" v-if="provisao.situacao >= 3" v-tooltip="'Liberada'" data-original-title="'Liberada'"></i>
                                            <i class="fa fa-exclamation-triangle provisaoaguardando" v-if="provisao.situacao == 2" v-tooltip="'Não liberada'" data-original-title="'Não liberada'"></i>
                                            <i class="fa fa-times-circle provisaopendente" v-if="provisao.situacao == 1" v-tooltip="'Pendente'" data-original-title="'Pendente'"></i>
                                        </td>
                                        <td>{{ provisao.dataProvisao | formatarData }}</td>
                                        <td>{{ provisao.nomeProjeto || '---' }}</td>
                                        <td>{{ provisao.beneficiario || '---' }}</td>
                                        <td>{{ provisao.valor | formatarNumero }}</td>
                                        <td>{{ provisao.dataPrevisao | formatarData('---') }}</td>
                                        <td>{{ provisao.dataEfetivacao | formatarData('---') }}</td>
                                        <td>{{ provisao.contrato || '---' }}</td>
                                        <td>{{ status(provisao) }}</td>
                                        <td>
                                            <checkbox class="ckbselecionado" v-if="provisao.situacao == 2" v-model="provisao.selecionado" :disabled="provisao.disabledSelecionado" value="1" type="success" true-value="1" false-value="0">
                                            </checkbox>
                                        </td>
                                    </tr>
                                    <tr v-show="carregando">
                                        <td colspan="12">
                                            <i class='fa fa-spinner fa-pulse'></i> Carregando...
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="row">
                            <div class="text-right">

                                <button class="btn btn-primary"
                                        style="margin-right: 70px;"
                                        v-tooltip="'Liberar provisões'"
                                        v-if="visibilidadeBotaoGerarProvisao"
                                        @click="mostrarModalLiberarProvisoes">
                                    <i class="fa fa-check"></i> Liberar provisões
                                </button>

                            </div>
                        </div>

                        <paginacao :page-count="totalPaginas"
                                   :click-handler="lista"
                                   :per-page="registrosPorPagina"
                                   :register-count="totalRegistros"
                                   :show-counter="true"
                                   ref="paginacao">
                        </paginacao>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .liberacao {
        font-size: 1.20em;
        color: #1d9d74;
        margin-right: 3px;
    }

    .provisaoliberada {
        font-size: 1.40em;
        color: #1d9d2d;
    }

    .provisaoaguardando {
        font-size: 1.40em;
        color: #a6a915;
    }

    .provisaopendente {
        font-size: 1.40em;
        color: #f11919;
    }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/liberar-provisoes-pagamento/componentes/LiberarProvisoesPagamentoLista.vue